import styled, { css } from 'styled-components/macro'

import { settings } from '../../../styled/settings/index';
import { mixins } from '../../../styled/mixins/index';

const {
  colors: { color, hexToRGBa },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletLandscapeUp, tabletPortraitDown, tabletPortraitUp },
  sizing: { spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  layout: { centered, centeredContent, pageSection, pageSectionInner },
  typography: { buttonText, heading1, heading2, heading5, heroDescription, linkButtonText },
} = mixins;

export const PageSection = styled.section`
  ${pageSection}
  color: ${(props) => props.fontColor ? color(props.fontColor) : color(`white`)};

  /* stylelint-disable comment-empty-line-before */
  ${(props) => (props.backgroundColor) && css`
    background-color: ${color(props.backgroundColor)};
  `}
  /* stylelint-enable */

  &:after {
    clear: both;
  }
`;

export const Container = styled.div`
  ${pageSectionInner}

  @media ${tabletLandscapeUp} {
    margin-right: auto;
    margin-left: auto;
    display: grid;
    grid-template-columns: auto auto;

    @media ${tabletLandscapeDown} {
      grid-template-columns: 70fr 30fr;
    }

    @media ${tabletPortraitDown} {
      grid-template-columns: 75fr 25fr;
    }

    @media ${mobileDown} {
      grid-template-columns: 85fr 15fr;
    }
  }
`;

export const EventContentContainer = styled.div`

`;

export const EventImageContainer = styled.div`

`;

export const Image = styled.img`
  width: 100%;
  height: auto;

  @media ${tabletPortraitDown} {
    /* display: none; */
  }
`;

export const Title = styled.h1`
  ${heading1}
  margin-bottom: 0;
  text-transform: uppercase;
  width: 100%;
  color: ${(props) => props.titleColor ? color(props.titleColor) : color(`teal`)};
  border-bottom: solid 0.625rem ${(props) => props.titleColor ? color(props.titleColor) : color(`teal`)};
`;

export const Description = styled.p`
  ${heroDescription}
  padding: ${spacingsize(10)};

  ul {
    list-style: none;
    padding-left: 0;
  }

  a:hover {
    color: ${color(`teal`)};
  }
`;

export const Clearfix = styled.div`
  clear: both;
`;